import React from 'react'

import Dropdown from "./ReactDropdown";

export default class DropdownSchoolYear extends Dropdown
{		
	
	// Entry properties
	//
	// mode : 'list' - Just act like a dropdown with each role itemised
	//        'filter' - act as a drop down filter list, including an 'ALL' option

	static get defaultProps()
	{
		let v =
			{
				mode: 'list',
				label: '',
				defaultValue: 0,
				maxValue: 19,
				containerClassName: '',
			}

		return v;
	}
	
	constructor(props) 
	{
		super(props);
		
		this.keyCount = 0 ;

		if ( this.props.defaultValue == null || this.props.defaultValue > 19)
		{
			var def = 0 ;
		}
		else
		{
			def = this.props.defaultValue ;
		}


    	// Create a state item here
		this.state = { dirty: false, currentValue: def, items: null };

	}

	UNSAFE_componentWillMount()
	{		
		// This is a callback to tell the parent our ID so it can talk to this contrao
		if ( this.props.parentRef != null )
		{
			this.props.parentRef ( this.props.id, this ) ;		
		}
		
		// Fetch the list of types to populste the dropdown
		this.getdata () ;
	}
	
	getdata( )
	{
		var progresstypes = [
			{
				id: 17,
				desc: 'Early Years'
			},
		  {
		    id: 14,
		    desc: 'Nursery'
		  },
		  {
		    id: 15,
		    desc: 'Reception'
		  },
		  {
		    id: 1,
		    desc: 'Year 1'
		  },
		  {
		    id: 2,
		    desc: 'Year 2'
		  },
		  {
		    id: 3,
		    desc: 'Year 3'
		  },
		  {
		    id: 4,
		    desc: 'Year 4'
		  },
		  {
		    id: 5,
		    desc: 'Year 5'
		  },
		  {
		    id: 6,
		    desc: 'Year 6'
		  },
		  {
		    id: 7,
		    desc: 'Year 7'
		  },
		  {
		    id: 8,
		    desc: 'Year 8'
		  },
		  {
		    id: 9,
		    desc: 'Year 9'
		  },
		  {
		    id: 10,
		    desc: 'Year 10'
		  },
		  {
		    id: 11,
		    desc: 'Year 11'
		  },
		  {
		    id: 12,
		    desc: 'Year 12'
		  },
		  {
		    id: 13,
		    desc: 'Year 13'
		  },
			{
				id: 16,
				desc: 'Year 14'
			},		  {
				id: 18,
				desc: 'Year 15'
			},		  {
				id: 19,
				desc: 'Year 16'
			},
		];
				
		this.setState ( { items : progresstypes } ) ;
	}

	sendChangeNotification()
	{
		if ( this.state.dirty == false )
		{
			if ( this.props.onDirty != null )
			{
				// Send a dirty notification if required, and only the first time we change
				this.props.onDirty() ;
			}
		}
	}

	handleChange(e) 
	{
		var targetName = e.target.name ;
		var val = e.target.value ;
		var index = e.target.selectedIndex;

		// Need to calculate the offset to read the actual Type Id from the correct place in the table
		// If it is a 'filter' then there is an extra entry in the listbox called 'ALL' which we need to account for
		
		var offset = -1 ;

		if ( index > 0 )
		{
			var itemid = this.state.items[index+offset].id;			
			var itemtext = this.state.items[index+offset].desc ;

			this.sendChangeNotification() ;

			this.setState ( {dirty: true, currentValue: itemid} ) ;
		}
		else
		{
			var itemid = 0 ;		
			var itemtext = "All" ;

			this.sendChangeNotification() ;

			this.setState ( {dirty: true, currentValue: itemid} ) ;
		}
		
		// Tell the owning function about the change	
		
		if ( this.props.callback != null )
		{
			this.props.callback ( itemtext, itemid ) ;
		}
		
	}
	  
	/**
	* Returns true if the input value complies with the validation rules supplied
	* 
	* @param {string} param - The value of the string to be tested.
	* @return {bool} true if the test passes.
	*/
	isValueValid( param )
	{
		if ( this.props.validation != null )
		{
			if ( this.props.validation.required == true )
			{
				if ( param == null || param == 0)
				{
					return false ;
				}
			}
			else
			{
				if ( param == null || param == 0)
				{
					// If not required, and empty, it's OK
					return true ;
				}
			}			
		}

		return true ;
	}

	/**
	* Externally callable function to test if the input field is valid
	* 
	* @return {bool} True if the field is valid.
	*/
	/* isValid()
	{		
		return this.isValueValid ( this.getValue() ) ;
	}*/
	
    getValue()
    {
    	return this.state.currentValue ;
    }
    
	/**
	* Externally callable function to test if the input field is valid
	* 
	* @return {bool} True if the field is valid.
	*/
	/*
	isDirty()
	{		
		return this.state.dirty ;
	}

	setDirty ( value )
	{
		this.setState ({dirty: value}) ;
	}
	*/
	
    optionList ()
    {
        var lineList=[];
        
        // This element renders from the list of user types returned by the getdata() ajax function above
    	var itemArray = this.state.items ;

    	if ( itemArray != null )
        {
        	var i = 0 ;
            var len = itemArray.length;
            var row = null ;
            var typeId = null ;
            var typeText = null ;
            
            // If it's a filter list, add the 'ALL' option
            
    		lineList.push(React.createElement ( 'option', {key: "ddyopt0", name: 0, value: 0} , 'Select a Value'));
    		
            for (i=0; i<len; ++i) 
            {
            	if (i in itemArray) 
            	{
            		row = itemArray[i];
            		
            		typeId = row.id ;
            		typeText = row.desc;
            		
            		lineList.push(React.createElement ( 'option', {key: "ddyopt" + typeId, name: typeId, value: typeId} , typeText));
            	}
            }
        }
        
        return lineList ;
    }
    
    dropdown_select ( id )
    {
    	return React.createElement ( 'select', {key: "sel" + this.props.id , value: this.state.currentValue, tabIndex: this.props.tabIndex, className: 'form-control', id: id , onChange: this.handleChange.bind(this)}, this.optionList() ) ;
    }

    render() 
    {
		this.keyCount = 0 ;

		if ( this.props.readOnly != 'readonly' )
		{
			return React.createElement ( 'div', {key: "containerro"+this.props.id, className: this.props.containerClassName}, this.optionDropdown('list1')) ;
		}
		else
		{
			return React.createElement ( 'div', {key: "container" + this.props.id}, this.readOnlyField()) ;
		}
    }
};


